import { Divider, Fade, Typography } from "@mui/material";
import { ArrowForwardIos } from "@mui/icons-material";

import { Button, PageHeader } from "../../components";
import myPackage from "../../../package.json";
import { useAuth } from "../../contexts";
import * as s from "./styles";
import { useHistory } from "react-router-dom";

const Training = () => {
  const history = useHistory();
  const { isVisitant, client, signOut } = useAuth();

  return (
    <Fade in timeout={1000}>
      <s.PageContainer>
        <PageHeader label={"Perfil"} handleBackPress={() => {}} />
        <s.TrainingContainer>
          <Fade in timeout={1000}>
            <div>
              <Typography variant="caption" color="gray">
                Olá,
              </Typography>
              {isVisitant ? (
                <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
                  Visitante
                </Typography>
              ) : (
                <>
                  <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
                    {client.name}
                  </Typography>
                  <Typography variant="caption" color="gray">
                    Plano atual •{" "}
                    {new Date(client.dueDate).toLocaleDateString()}
                  </Typography>
                  <Typography>
                    {client.plan} • Nível {client.level}
                  </Typography>
                </>
              )}
              <Divider sx={{ mt: "3rem" }} />
              {!isVisitant && (
                <>
                  <Button
                    variant="text"
                    color="inherit"
                    fullWidth
                    size="large"
                    endIcon={
                      <ArrowForwardIos sx={{ fontSize: "1rem !important" }} />
                    }
                    sx={{
                      m: 0,
                      padding: "1rem 0",
                      justifyContent: "space-between",
                      borderRadius: 0,
                    }}
                    onClick={() => history.push("/profile/training-sheet")}
                  >
                    Ficha do aluno
                  </Button>
                  <Divider />
                  <Button
                    variant="text"
                    color="inherit"
                    fullWidth
                    size="large"
                    endIcon={
                      <ArrowForwardIos sx={{ fontSize: "1rem !important" }} />
                    }
                    sx={{
                      m: 0,
                      padding: "1rem 0",
                      justifyContent: "space-between",
                      borderRadius: 0,
                    }}
                    onClick={() => history.push("/profile/my-profile")}
                  >
                    Meu perfil
                  </Button>
                  <Divider />
                </>
              )}

              <Button
                variant="text"
                color="inherit"
                fullWidth
                size="large"
                endIcon={
                  <ArrowForwardIos sx={{ fontSize: "1rem !important" }} />
                }
                sx={{
                  m: 0,
                  padding: "1rem 0",
                  justifyContent: "space-between",
                  borderRadius: 0,
                }}
                onClick={() => history.push("/profile/privacy-policy")}
              >
                Política de privacidade
              </Button>
              <Divider />
              <Button
                variant="text"
                color="inherit"
                fullWidth
                size="large"
                sx={{
                  color: "#F44336",
                  m: 0,
                  padding: "1rem 0",
                  justifyContent: "space-between",
                  borderRadius: 0,
                }}
                onClick={() => signOut()}
              >
                Sair
              </Button>
              <Divider />
              <Typography variant="body2" sx={{ mt: 2, opacity: 0.2 }}>
                Versão {myPackage.version}
              </Typography>
            </div>
          </Fade>
        </s.TrainingContainer>
      </s.PageContainer>
    </Fade>
  );
};

export default Training;
